import { Flex, IconArrowRight, IconStarFilled } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';
import styled from 'styled-components';
import ModuleList from './ModuleList';
import BreadCrumbItem from '../shared/BreadCrumbItem';

interface UserProfileProps {
    onUserUpdateAfterRefreshingToken: () => void;
}

const UserProfile: FunctionComponent<UserProfileProps> = (props) => {
    const { t } = useTranslation();
    const context = useContext(AppContext);
    const user = context.user!;

    return (
        <Flex
            width="100%"
            height="100%"
            maxWidth="calc(100vw - 84px)"
            className="vertical-scrollbar"
            bg="backgroundPaper"
        >
            <Flex flexDirection='column' alignItems='start' width='100%'>
                <Flex justifyContent='start' alignItems='center' gap='16px' pl='16px' pt='16px' pb='16px' width='100%' height='66px'>
                    <Flex justifyContent='center' alignItems='center' gap='8px'>
                        <BreadCrumbItem label={user.orgName || 'User'} />
                        <IconArrowRight width={16} height={16} />
                    </Flex>
                    <BreadCrumbItem label={t('UserProfile.table_title', 'My Apps')} icon={<IconStarFilled width={16} height={16}/>} isHighlighted />
                </Flex>
                <StyledFlex>
                    <ModuleList />
                </StyledFlex>
            </Flex>
        </Flex>
    );
};

const StyledFlex = styled(Flex)`
    width: 100%;
    border-top: 2px solid ${props => props.theme.colors.background};
    padding: 16px;
    height: 100%
`;

export default UserProfile;